// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import toast from "react-hot-toast";
// import Cookies from "js-cookie";
// import loginService from "../../Services/loginService";
// import { Button, Grid, TextField, IconButton } from "@mui/material";
// import Visibility from "@mui/icons-material/Visibility";
// import VisibilityOff from "@mui/icons-material/VisibilityOff";
// import logo from "../../assets/logo.png";

// const Login = () => {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [data, setData] = useState({
//     email: "",
//     password: "",
//   });
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);

//   const [regex] = useState({
//     email: /.+@.+\..+/,
//     password: /.{6,}/,
//   });

//   const handleChange = (value, field) => {
//     setData((prevData) => ({ ...prevData, [field]: value }));
//     setError("");
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault(); // Prevent default form submission
//     try {
//       const response = await loginService.login(data);
//       toast.success("Login successful!");
//       // Set authentication cookie
//       Cookies.set(
//         "XIOQUNVU1RPTUVSLUFVVEhFTlRJQ0FUSU9OIMSLQ1JFVC1LRVk=",
//         response.token,
//         { expires: 1 }
//       );
//       // Update authentication state in App component
//       setIsAuthenticated(true); // This will trigger the redirect
//       // Redirect to /receptionist after successful login
//       navigate("/staff");
//     } catch (error) {
//       toast.error(error.message || "Login failed. Please try again.");
//     }
//   };

//   const handleKeyDown = (event) => {
//     if (event.key === "Enter") {
//       handleSubmit(event);
//     }
//   };

//   // Toggle password visibility
//   const handleClickShowPassword = () => {
//     setShowPassword(!showPassword);
//   };

//   return (
//     <div>
//       <div className="min-h-screen bg-gray-100 py-6 flex flex-col justify-center sm:py-12">
//         <div className="relative py-3 sm:max-w-xl sm:mx-auto">
//           <div className="relative px-4 py-10 bg-zinc-200 shadow-lg sm:rounded-md sm:p-20">
//             <div className="max-w-md mx-auto">
//               <div>
//                 <div className="text-center mb-6">
//                   <img
//                     src={logo}
//                     alt="Hospital Logo"
//                     className="mx-auto w-30 h-28"
//                   />
//                 </div>
//               </div>
//               <div className="divide-y divide-gray-200">
//                 <input
//                   type="email"
//                   placeholder="Enter Your Email"
//                   value={data.email}
//                   onChange={(e) => handleChange(e.target.value, "email")}
//                   onKeyDown={handleKeyDown}
//                   className="border-b-2 rounded-md border-gray-200 p-2 w-[90%] mt-10 focus:outline-none font-normal"
//                 />

//                 <input
//                   type={showPassword ? "text" : "password"}
//                   placeholder="Enter Password"
//                   value={data.password}
//                   onChange={(e) => handleChange(e.target.value, "password")}
//                   onKeyDown={handleKeyDown}
//                   className="border-b-2 rounded-md border-gray-200 p-2 w-[90%] mt-5 focus:outline-none focus:border-[#1EA56C]"
//                 />

//                 <IconButton
//                   onClick={handleClickShowPassword}
//                   className="absolute right-12 top-4 transform -translate-y-1/2"
//                 >
//                   {showPassword ? <VisibilityOff /> : <Visibility />}
//                 </IconButton>

//                 {/* Show error message */}
//                 {error && <p className="text-red-500 mt-3">{error}</p>}

//                 <div className="flex justify-center">
//                   <button
//                     className={`bg-[#787878] hover:border-none text-white hover:text-white p-2 px-10 rounded-md mt-10 font-semibold shadow-md hover:shadow-slate-700 duration-300 ${
//                       loading ? "opacity-50 cursor-not-allowed" : ""
//                     }`}
//                     onClick={handleSubmit}
//                     disabled={loading}
//                   >
//                     {loading ? "Loading..." : "Login"}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;


import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import loginService from "../../Services/loginService";
import logo from "../../assets/logo2.png";
import {
  MdEmail,
  MdLock,
  MdVisibility,
  MdVisibilityOff,
  MdErrorOutline,
  MdArrowForward,
} from "react-icons/md";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [data, setData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [focused, setFocused] = useState("");

  const handleChange = (value, field) => {
    setData((prev) => ({ ...prev, [field]: value }));
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await loginService.login(data);
      toast.success("Login successful!");
      Cookies.set(
        "XIOQUNVU1RPTUVSLUFVVEhFTlRJQ0FUSU9OIMSLQ1JFVC1LRVk=",
        response.token,
        { expires: 1 }
      );
      setIsAuthenticated(true);
      navigate("/staff");
    } catch (error) {
      toast.error(error.message || "Login failed. Please try again.");
      setError(error.message || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSubmit(e);
  };

  return (
    <div
      className="min-h-screen flex overflow-hidden"
      style={{ fontFamily: "'DM Sans', sans-serif" }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap');
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .fade-up { animation: fadeUp 0.7s ease both; }
      `}</style>

      {/* ── Left decorative panel ── */}
      <div
        className="hidden md:flex w-[45%] flex-col justify-between p-12 relative overflow-hidden"
        style={{
          background: "linear-gradient(155deg,  #90E0EF  0%, #03045E 100%)",
        }}
      >
        {/* Decorative circles */}
        <div className="absolute -top-28 -right-28 w-[420px] h-[420px] rounded-full bg-white/[0.04] pointer-events-none" />
        <div className="absolute -bottom-20 -left-20 w-[300px] h-[300px] rounded-full bg-white/[0.04] pointer-events-none" />

        {/* Brand */}
       <div className="flex items-center z-10">
  <img
    src={logo}
    alt="Hospital Logo"
    className="w-28 h-28 object-contain scale-125"
  />

  <span
    className="text-white text-xl tracking-wide pb-2"
    style={{ fontFamily: "'DM Serif Display', serif" }}
  >
    Hospital Management System
  </span>
</div>

        {/* Headline */}
        <div className="relative z-10">
          <h1
            className="text-white text-[42px] leading-[1.15] mb-5"
            style={{ fontFamily: "'DM Serif Display', serif" }}
          >
           Building better teams,
            <br />
            <em className="not-italic text-[#215187]">starting here,</em>
            <br />
           every day.
          </h1>
          <p className="text-white/55 text-[15px] leading-[1.7] max-w-[300px] font-light">
            Manage your people smarter — recruitment, tracking, and development in one platform.
          </p>
        </div>

        {/* Stats */}
        <div className="flex gap-9 relative z-10">
          {[
            { num: "24/7", label: "Patient Support" },
            { num: "1K+", label: "Daily Visits" },
            { num: "200+", label: "Staff Members" },
          ].map((s, i) => (
            <React.Fragment key={s.label}>
              {i > 0 && <div className="w-px bg-white/15 self-stretch" />}
              <div className="flex flex-col gap-1">
                <span
                  className="text-white text-[26px]"
                  style={{ fontFamily: "'DM Serif Display', serif" }}
                >
                  {s.num}
                </span>
                <span className="text-[11px] text-white/40 uppercase tracking-[0.8px] font-medium">
                  {s.label}
                </span>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* ── Right form panel ── */}
      <div className="flex-1 flex items-center justify-center px-8 py-10 bg-white">
        <div className="w-full max-w-[420px] fade-up">
          <h2
            className="text-[#0a2540] text-[32px] mb-1"
            style={{ fontFamily: "'DM Serif Display', serif" }}
          >
            Welcome back
          </h2>
          <p className="text-[#8a9bb0] text-sm mb-10">
            Sign in to your HR portal
          </p>

          {/* Email field */}
          <FieldGroup label="Email Address">
            <FieldWrap focused={focused === "email"} icon={<MdEmail size={18} />}>
              <input
                className="w-full pl-11 pr-4 py-[14px] border-[1.5px] border-[#dde4ed] rounded-xl text-[15px] text-[#0a2540] bg-white outline-none transition-all placeholder:text-[#b0bcc9] focus:border-[#e96f1f] focus:shadow-[0_0_0_4px_rgba(233,111,31,0.1)]"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
                type="email"
                placeholder="Enter your email"
                value={data.email}
                onChange={(e) => handleChange(e.target.value, "email")}
                onFocus={() => setFocused("email")}
                onBlur={() => setFocused("")}
                onKeyDown={handleKeyDown}
              />
            </FieldWrap>
          </FieldGroup>

          {/* Password field */}
          <FieldGroup label="Password">
            <FieldWrap focused={focused === "password"} icon={<MdLock size={18} />}>
              <input
                className="w-full pl-11 pr-11 py-[14px] border-[1.5px] border-[#dde4ed] rounded-xl text-[15px] text-[#0a2540] bg-white outline-none transition-all placeholder:text-[#b0bcc9] focus:border-[#e96f1f] focus:shadow-[0_0_0_4px_rgba(233,111,31,0.1)]"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={data.password}
                onChange={(e) => handleChange(e.target.value, "password")}
                onFocus={() => setFocused("password")}
                onBlur={() => setFocused("")}
                onKeyDown={handleKeyDown}
              />
              <button
                type="button"
                className="absolute right-3 top-1/2 -translate-y-1/2 text-[#8a9bb0] hover:text-[#e96f1f] transition-colors p-1 rounded-md"
                onClick={() => setShowPassword(!showPassword)}
                tabIndex={-1}
              >
                {showPassword ? (
                  <MdVisibilityOff size={18} />
                ) : (
                  <MdVisibility size={18} />
                )}
              </button>
            </FieldWrap>
          </FieldGroup>

          {/* Error message */}
          {error && (
            <p className="flex items-center gap-1.5 text-[13px] text-[#e05c5c] -mt-3 mb-4">
              <MdErrorOutline size={16} />
              {error}
            </p>
          )}

          {/* Submit button */}
          <button
            className="w-full py-[15px] rounded-xl text-white text-base font-semibold tracking-[0.3px] transition-all disabled:opacity-65 disabled:cursor-not-allowed hover:enabled:-translate-y-px"
            style={{
              background: "linear-gradient(135deg, #2F6DB4 0%, #255A8C 100%)",
               boxShadow: "0 2px 10px #255A8C",
              fontFamily: "'DM Sans', sans-serif",
            }}
            onClick={handleSubmit}
            disabled={loading}
          >
            <span className="flex items-center justify-center gap-2.5">
              {loading ? (
                <>
                  <AiOutlineLoading3Quarters size={18} className="animate-spin" />
                  Signing in…
                </>
              ) : (
                <>
                  Sign In
                  <MdArrowForward size={18} />
                </>
              )}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

/* ── Helper components ── */

const FieldGroup = ({ label, children }) => (
  <div className="mb-5 relative">
    <label
      className="block text-[11px] font-semibold tracking-[0.8px] uppercase text-[#4a6080] mb-2"
      style={{ fontFamily: "'DM Sans', sans-serif" }}
    >
      {label}
    </label>
    {children}
  </div>
);

const FieldWrap = ({ focused, icon, children }) => (
  <div className="relative flex items-center">
    <span
      className={`absolute left-4 flex items-center pointer-events-none transition-colors ${
        focused ? "text-[#e96f1f]" : "text-[#8a9bb0]"
      }`}
    >
      {icon}
    </span>
    {children}
  </div>
);

export default Login;